import {
    EfeResponse,
    RecoverPasswordResponse,
    ResetPasswordValues,
    SecurityUsersRequest,
    SecurityUsersResponse,
    ValidateTokenResponse,
} from 'commons/models';
import EfeApi from 'services/api/Api';

async function getUsers(params: SecurityUsersRequest): Promise<EfeResponse<SecurityUsersResponse>> {
    try {
        return await EfeApi.Security.get<SecurityUsersResponse>('/api/v1/users', {
            params: params,
        }).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function recoverCredentials(username: string): Promise<EfeResponse<RecoverPasswordResponse>> {
    try {
        const usernameValue = encodeURIComponent(username);
        console.log(usernameValue);
        return await EfeApi.Security.post<RecoverPasswordResponse>(
            `/api/v1/users/recovery-password?username=${usernameValue}`
        ).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function validateRecoveryToken(token: string): Promise<EfeResponse<ValidateTokenResponse>> {
    try {
        return await EfeApi.Security.get<ValidateTokenResponse>('/api/v1/users/reset-password', {
            params: {
                token: token,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function resetPassword(
    values: ResetPasswordValues,
    token: string
): Promise<EfeResponse<RecoverPasswordResponse>> {
    try {
        return await EfeApi.Security.put<RecoverPasswordResponse>(
            '/api/v1/users/reset-password',
            {
                token: token,
                newPassword: values.newPassword,
                passwordConfirmed: values.passwordConfirmed,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        ).then((response) => {
            return Promise.resolve({
                data: response.data,
                status: 'Success',
                success: true,
                code: response.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    getUsers,
    recoverCredentials,
    validateRecoveryToken,
    resetPassword,
};
